import Vue from 'vue';
import moment from 'moment';
import { cloneDeep } from 'lodash';

const INIT_CMS_USER = {
  // ユーザー情報
  inputData: {
    sei: null,
    mei: null,
    kana_sei: null,
    kana_mei: null,
    mail_address: null,
    affiliated_institution: null,
    position: null,
    password: null,
    password_twice: null,
    allowed_from: null,
    allowed_to: null,
    authes: [],
    changeEmail: false,
    changePassword: false,
    changeTerm: false,
  },
  errors: [],
  isSend: false,
};

export default {
  namespaced: true,
  state: cloneDeep(INIT_CMS_USER),
  mutations: {
    setDbData(state, user) {
      if (user) {
        state.inputData.sei = user.sei;
        state.inputData.mei = user.mei;
        state.inputData.kana_sei = user.kana_sei;
        state.inputData.kana_mei = user.kana_mei;
        state.inputData.mail_address = user.mail_address;
        state.inputData.affiliated_institution = user.affiliated_institution;
        state.inputData.position = user.position;
        state.inputData.password = user.password;
        state.inputData.password_twice = user.password_twice;
        state.inputData.allowed_from = user.allowed_from && moment(user.allowed_from).format('YYYY/MM/DD');
        state.inputData.allowed_to = user.allowed_to && moment(user.allowed_to).format('YYYY/MM/DD');
        state.inputData.authes = user.authes;
        state.inputData.changeEmail = user.changeEmail;
        state.inputData.changePassword = user.changePassword;
        state.inputData.changeTerm = user.changeTerm;
      }
    },
    // ユーザー情報
    updateFamilyName(state, value) {
      state.inputData.sei = value;
    },
    updateFirstName(state, value) {
      state.inputData.mei = value;
    },
    updateFamilyNameKana(state, value) {
      state.inputData.kana_sei = value;
    },
    updateFirstNameKana(state, value) {
      state.inputData.kana_mei = value;
    },
    updateMail_address(state, value) {
      state.inputData.mail_address = value;
    },
    updateAffiliated_institution(state, value) {
      state.inputData.affiliated_institution = value;
    },
    updatePosition(state, value) {
      state.inputData.position = value;
    },
    updatePassword(state, value) {
      state.inputData.password = value;
    },
    updatePassword_twice(state, value) {
      state.inputData.password_twice = value;
    },
    updateAllowed_from(state, value) {
      const t = moment(value, 'YYYY/MM/DD').isValid() ? value : null;
      state.inputData.allowed_from = t;
    },
    updateAllowed_to(state, value) {
      const t = moment(value, 'YYYY/MM/DD').isValid() ? value : null;
      state.inputData.allowed_to = t;
    },
    updateAuthes(state, value) {
      state.inputData.authes = value;
    },
    isChangeEmail(state, value) {
      state.inputData.changeEmail = value;
    },
    isChangePassword(state, value) {
      state.inputData.changePassword = value;
    },
    isChangeTerm(state, value) {
      state.inputData.changeTerm = value;
    },
    // エラー関連
    setErrorMsg(state, errors) {
      state.errors = errors;
    },
    addErrorMsg(state, errors) {
      Vue.set(state.errors, errors.key, errors.msg);
    },
    deleteErrMsg(state, target) {
      Vue.delete(state.errors, target);
    },
    requiredRegistryTimes(state) {
      let result = (
        state.inputData.sei
        && state.inputData.mei
        && state.inputData.kana_sei
        && state.inputData.kana_mei
        && (state.inputData.password !== null && state.inputData.password !== '')
        && state.inputData.password === state.inputData.password_twice
        && state.inputData.mail_address
        && state.inputData.authes.length > 0
      ) || false;

      if (state.inputData.changeTerm) result = (result && state.inputData.allowed_from) || false;
      state.isSend = result;
    },
    requiredUpdateTimes(state) {
      let result = (
        state.inputData.sei
        && state.inputData.mei
        && state.inputData.kana_sei
        && state.inputData.kana_mei
        && state.inputData.authes.length > 0
      ) || false;

      if (state.inputData.changeEmail) result = (result && state.inputData.mail_address) || false;
      if (state.inputData.changeTerm) result = (result && state.inputData.allowed_from) || false;
      if (state.inputData.changePassword) {
        result = ((result && state.inputData.password === state.inputData.password_twice)
          && (state.inputData.password !== null && state.inputData.password !== '')
          && (state.inputData.password === state.inputData.password_twice)) || false;
      }
      state.isSend = result;
    },
  },
  actions: {
    init({ commit }) {
      commit('setDbData', INIT_CMS_USER.inputData);
    },
    checkMarks({ commit, state }, user) {
      if (user.id) return commit('requiredUpdateTimes');
      return commit('requiredRegistryTimes', state);
    },
    editItem({ commit }, item) {
      commit('setDbData', item);
      if (item.allowed_from !== null || item.allowed_to !== null) commit('isChangeTerm', true);
    },
    resetItem({ commit }, target) {
      if (!target.value) {
        if (target.name === 'email') {
          commit('updateMail_address', '');
          commit('deleteErrMsg', 'mail_address');
        }
        if (target.name === 'password') {
          commit('updatePassword', '');
          commit('updatePassword_twice', '');
          commit('deleteErrMsg', 'password');
          commit('deleteErrMsg', 'password_twice');
        }
      }
    },
    resetFlg({ commit }) {
      commit('isChangeEmail', false);
      commit('isChangePassword', false);
    },
    resetErrorMsg({ commit }) {
      commit('setErrorMsg', []);
    },
  },
};
